import { pstyle } from "../lib/pstyle.js";

export default function Certif({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1120px; margin:0 auto; display:flex; flex-direction:column; gap:32px;")}>
      <div style={pstyle("display:flex; align-items:flex-end; gap:40px;")}>
        <div style={pstyle("display:flex; flex-direction:column; gap:10px; flex:1;")}>
          <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; letter-spacing:0.1em; text-transform:uppercase; color:oklch(0.46 0.075 55);")}>{v.certifExam}</span>
          <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Préparation par domaine d'examen</h1>
          <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60); max-width:58ch;")}>Pondération officielle × maîtrise mesurée sur vos quiz et révisions. Les lacunes d'abord, pas l'ordre du programme.</p>
        </div>
        <div style={pstyle("display:flex; flex-direction:column; gap:4px; align-items:flex-end;")}>
          <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:40px; letter-spacing:-0.03em;", { color: v.certifScoreColor })}>{v.certifScore}</span>
          <span style={pstyle("font-size:12.5px; color:oklch(0.55 0.015 60);")}>score prévisionnel · seuil 82,5 %</span>
          <span style={pstyle("font-size:12.5px; color:oklch(0.5 0.015 60);")}>{v.certifDate}</span>
        </div>
      </div>

      <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap;")}>
        {v.certifTabs.map((t, i) => (
          <button key={i} type="button" onClick={t.onClick} style={pstyle("font:inherit; font-size:13px; border-radius:999px; padding:6px 14px; cursor:pointer;", { border: "1px solid " + t.border, color: t.color, background: t.bg })}>{t.label}</button>
        ))}
      </div>

      <div style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 300px; gap:44px; align-items:start;")}>
        <div style={pstyle("display:flex; flex-direction:column;")}>
          <div style={pstyle("display:grid; grid-template-columns:1fr 74px 200px 92px; font-size:12px; font-weight:600; letter-spacing:0.05em; text-transform:uppercase; color:oklch(0.55 0.015 60); border-bottom:1px solid oklch(0.93 0.008 85); padding-bottom:9px;")}>
            <span>Domaine</span><span style={pstyle("text-align:right;")}>Poids</span><span style={pstyle("text-align:right;")}>Maîtrise</span><span style={pstyle("text-align:right;")}>Écart</span>
          </div>
          {v.certifDomains.map((d, i) => (
            <button key={i} type="button" onClick={d.onClick} style={pstyle("background:none; border:none; border-bottom:1px solid oklch(0.96 0.006 85); text-align:left; width:100%; font:inherit; display:grid; grid-template-columns:1fr 74px 200px 92px; align-items:center; padding:15px 0; cursor:pointer;")}>
              <div style={pstyle("display:flex; flex-direction:column; gap:3px;")}>
                <span style={pstyle("font-size:14.5px; color:oklch(0.26 0.015 60);")}>{d.name}</span>
                <span style={pstyle("font-size:12px; color:oklch(0.53 0.015 60);")}>{d.detail}</span>
              </div>
              <span style={pstyle("text-align:right; font-family:'IBM Plex Mono', monospace; font-size:12.5px; color:oklch(0.5 0.015 60);")}>{d.weight}</span>
              <div style={pstyle("display:flex; align-items:center; gap:10px; padding-left:24px;")}>
                <div style={pstyle("flex:1; height:6px; border-radius:3px; background:oklch(0.94 0.006 85); overflow:hidden;")}>
                  <div style={pstyle("height:100%;", { width: d.pct + "%", background: d.color })}></div>
                </div>
                <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:12px; width:36px; text-align:right;", { color: d.color })}>{d.pct}%</span>
              </div>
              <span style={pstyle("text-align:right; font-size:12.5px;", { color: d.gapColor })}>{d.gap}</span>
            </button>
          ))}
        </div>

        <aside style={pstyle("display:flex; flex-direction:column; gap:24px;")}>
          <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:9px; padding:20px; display:flex; flex-direction:column; gap:12px;")}>
            <span style={pstyle("font-size:13px; font-weight:600;")}>Priorité cette semaine</span>
            {v.certifPriorities.map((p, i) => (
              <button key={i} type="button" onClick={p.onClick} style={pstyle("background:none; border:none; padding:0; text-align:left; font:inherit; display:flex; flex-direction:column; gap:3px; cursor:pointer;")}>
                <span style={pstyle("font-size:13.5px; color:oklch(0.28 0.015 60);")}>{p.title}</span>
                <span style={pstyle("font-size:12px; color:oklch(0.57 0.015 60);")}>{p.why}</span>
              </button>
            ))}
          </div>
          <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
            <span style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Historique de quiz</span>
            {v.certifAttempts.map((a, i) => (
              <div key={i} style={pstyle("display:flex; align-items:baseline; gap:10px; font-size:13px; color:oklch(0.42 0.015 60);")}>
                <span>{a.label}</span>
                <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:12px;", { color: a.color })}>{a.score}</span>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}
